import { render, staticRenderFns } from "./CharactersSpecies.vue?vue&type=template&id=1d498785&lang=pug&"
import script from "./CharactersSpecies.vue?vue&type=script&lang=ts&"
export * from "./CharactersSpecies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports